import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';

// @ts-expect-error migrate dependency
import { getId as getDashboardId } from 'dashboard-lib/public/dashboard/dashboard-schema';
import { selectDashboardFiltersGroupedByDataSource, selectDashboardFrequency } from '../../../../ducks/dashboardFilters';
import { useDataSourceMetaWithLoading } from 'platform-dashboard-ui/hooks/use-data-source-metadata';
import { useDataSourceProperties } from 'platform-dashboard-ui/hooks/use-data-source-properties';
// @ts-expect-error migrate dependency
import { getLabel as getDataSourceLabel } from '../../../../lib/dashboardFilters/dataSourceMetadataSchema';
import { DashboardFiltersList } from './DashboardFiltersList';
import { AppliedDashboardFiltersFrequencyDescription } from './DashboardFiltersFrequencyDescription';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { selectHasUnifiedFilterDashboard } from 'dashboard-lib/public/userInfo/gates';
import { AsyncDashboardCRMFiltersList as DashboardCRMFiltersList } from 'platform-dashboard-ui/components/dashboardFilter/filterDisplay/AsyncDashboardCRMFiltersList';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AppliedDashboardFilterListItemsWithDataSourceLabel = ({
  dataSourceLabel,
  dataSourceFilters
}) => {
  const hasUnifiedFilterDashboard = useSelector(selectHasUnifiedFilterDashboard);
  if (dataSourceFilters.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("strong", {
      children: dataSourceLabel
    }), hasUnifiedFilterDashboard ? /*#__PURE__*/_jsx(DashboardCRMFiltersList, {
      filters: dataSourceFilters
    }) : /*#__PURE__*/_jsx(DashboardFiltersList, {
      filters: dataSourceFilters
    })]
  });
};
export const AppliedDashboardFiltersList = ({
  dashboard
}) => {
  const dashboardId = getDashboardId(dashboard);
  const appliedDashboardFiltersGroupedByDataSource = useSelector(selectDashboardFiltersGroupedByDataSource(dashboardId));
  const appliedFilterDataSources = Object.keys(appliedDashboardFiltersGroupedByDataSource);
  const {
    isLoading: isDataSourceMetaLoading,
    dataSourceMetaData: dataSourcesMetadata,
    hasFailed: metadataHasError
  } = useDataSourceMetaWithLoading(appliedFilterDataSources);
  const {
    isLoading: isDataSourcePropertiesLoading,
    hasFailed: propertiesHasError
  } = useDataSourceProperties(appliedFilterDataSources);
  const isLoading = isDataSourceMetaLoading || isDataSourcePropertiesLoading;
  const hasError = metadataHasError || propertiesHasError;
  const appliedFrequency = useSelector(selectDashboardFrequency(dashboardId));
  const AppliedFiltersListItemsGroupedByDataSource = appliedFilterDataSources.map(dataSource => {
    const dataSourceMetadata = dataSourcesMetadata[dataSource];
    const dataSourceLabel = getDataSourceLabel(dataSourceMetadata);
    const dataSourceFilters = appliedDashboardFiltersGroupedByDataSource[dataSource].reduce((memo, filterObject) => [filterObject.filter /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */, ...memo], []);
    return /*#__PURE__*/_jsx(AppliedDashboardFilterListItemsWithDataSourceLabel, {
      dataSourceLabel: dataSourceLabel,
      dataSourceFilters: dataSourceFilters
    }, dataSource);
  });
  if (AppliedFiltersListItemsGroupedByDataSource.length === 0 && appliedFrequency == null) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "email.dashboard.noDashboardFiltersCurrentlyApplied"
    });
  }
  if (hasError) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboardHeader.dashboardFilters.allFilters.panel.error"
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: !isLoading ? /*#__PURE__*/_jsxs(ScrollContainer, {
      maxHeight: 200,
      children: [AppliedFiltersListItemsGroupedByDataSource.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "email.dashboard.currentlyAppliedDashboardFiltersLabel"
        }), /*#__PURE__*/_jsx("br", {}), AppliedFiltersListItemsGroupedByDataSource]
      }), /*#__PURE__*/_jsx(AppliedDashboardFiltersFrequencyDescription, {
        dashboardId: dashboardId
      })]
    }) : /*#__PURE__*/_jsx(UILoadingSpinner, {
      size: "xs",
      layout: "centered"
    })
  });
};